module.exports = __webpack_public_path__ + "img/ltkeaster-2x.0993fb1.jpg";